exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PreviewToken-module__token-wrapper___1tFAY{display:flex;justify-content:center;width:150px;height:150px}.PreviewToken-module__token-wrapper___1tFAY img.PreviewToken-module__token-image___BXJES{width:150px;height:150px;transition:all .15s ease;-o-object-fit:contain;object-fit:contain;-o-object-position:center;object-position:center}", ""]);

// exports
exports.locals = {
	"token-wrapper": "PreviewToken-module__token-wrapper___1tFAY",
	"token-image": "PreviewToken-module__token-image___BXJES"
};